import Vue from "vue";
import vuescroll from "vuescroll";

Vue.use(vuescroll, {
  ops: {
    vuescroll: {
      mode: "native",
      sizeStrategy: "number",
      detectResize: true
    },
    scrollPanel: {
      initialScrollY: false,
      initialScrollX: false,
      scrollingX: false,
      scrollingY: true,
      speed: 300,
      easing: "easeInOutQuint"
    },
    rail: {
      background: "#eeeeee",
      size: "8px",
      opacity: 0.3,
      border: 0
    },
    bar: {
      showDelay: 500,
      onlyShowBarOnScroll: true,
      keepShow: false,
      background: "grey",
      opacity: 0.8,
      hoverStyle: false,
      specifyBorderRadius: false,
      minSize: 0.2,
      size: "8px",
      disable: false
    }
  },
  name: "vue-scroll"
});
